// extracted by mini-css-extract-plugin
export var avatar = "_ot-3";
export var avatarContainer = "_ot-2";
export var avatarSpacer = "_ot-5";
export var avatarSpacerContainer = "_ot-4";
export var avatarStackContainer = "_ot-1";
export var bubble = "_ot-0";
export var remainderBubble = "_ot-6";